export default __webpack_public_path__ + "static/media/299.f9268cda.png";